export { default } from './FaqAccordion';
export type { FaqAccordionProps } from './FaqAccordion';
